
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/provider_portal",
      function () {
        return require("private-next-pages/provider_portal/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/provider_portal"])
      });
    }
  